import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import IngresoMuestraForm from '../components/IngresoMuestraForm';
import IngresoMuestrasTable from '../components/IngresoMuestrasTable';

const IngresoMuestraPage = () => {
  const { protocoloMuestra } = useParams();
  const location = useLocation();
  const protocoloGeneral = location.state?.protocoloGeneral || '';
  const sectorInicial = location.state?.sectorInicial === 'PACK_TORO' ? 'PACK_TORO' : '';
  const isEditMode = Boolean(protocoloMuestra);

  return (
    <div className="container page-shell">
      <div className="page-header">
        <div>
          <span className="section-kicker">{isEditMode ? 'Edicion' : 'Laboratorio'}</span>
          <h2 className="page-title">{isEditMode ? 'Editar muestra' : 'Ingreso de muestras'}</h2>
          <p className="page-subtitle">
            {isEditMode
              ? 'Actualiza la informacion de la muestra y vuelve al caso cuando termines.'
              : 'Carga y revisa varias muestras en una misma tabla.'}
          </p>
        </div>
        <img src="/logo-inta.png" alt="Logo INTA" className="page-header-logo" />
      </div>
      {isEditMode ? <IngresoMuestraForm sampleId={protocoloMuestra} /> : (
        <div className="surface-card">
          {protocoloGeneral && <Link className="btn btn-outline-brand mb-3" to={`/ver-caso/${protocoloGeneral}`}>Ver caso</Link>}
          <IngresoMuestrasTable key={`${protocoloGeneral}-${sectorInicial}`} protocoloGeneral={protocoloGeneral} sectorInicial={sectorInicial} />
        </div>
      )}
    </div>
  );
};

export default IngresoMuestraPage;
